var Industry = "อุตสาหกรรม";
var Aerospace = "ยานอวกาศ";
var Agriculture = "การเกษตร";
var Automotive = "ยานยนต์";
var Education = "การศึกษา";
var Gaming = "เกม";
var Government = "รัฐบาล";
var Healthcare = "การดูแลสุขภาพ";
var Hospitality = "การบริการ";
var Manufacturing = "การผลิต";
var Mining = "การทำเหมือง";
var Other = "อื่นๆ";
var Retail = "การค้าปลีก";
var Telecommunications = "โทรคมนาคม";
var Travel = "การท่องเที่ยว";
var industry = {
	Industry: Industry,
	Aerospace: Aerospace,
	Agriculture: Agriculture,
	Automotive: Automotive,
	"Computers & electronics": "คอมพิวเตอร์และอิเล็กทรอนิกส์",
	"Consumer goods": "สินค้าอุปโภคบริโภค",
	Education: Education,
	"Financial services": "บริการทางการเงิน",
	Gaming: Gaming,
	Government: Government,
	Healthcare: Healthcare,
	Hospitality: Hospitality,
	"Life sciences": "วิทยาศาสตร์ชีวภาพ",
	Manufacturing: Manufacturing,
	"Marketing & advertising": "การตลาดและการโฆษณา",
	"Media & entertainment": "สื่อและความบันเทิง",
	Mining: Mining,
	"Non-profit organization": "องค์กรที่ไม่หวังผลกำไร",
	"Oil & gas": "น้ำมันและก๊าซ",
	Other: Other,
	"Power & utilities": "พลังงานและสาธารณูปโภค",
	"Professional services": "บริการเฉพาะทาง",
	"Real estate & construction": "อสังหาริมทรัพย์และการก่อสร้าง",
	Retail: Retail,
	"Software & internet": "ซอฟต์แวร์และอินเทอร์เน็ต",
	Telecommunications: Telecommunications,
	"Transportation & logistics": "การขนส่งและโลจิสติกส์",
	Travel: Travel,
	"Wholesale & distribution": "การค้าส่งและการจัดจำหน่าย"
};

export { Aerospace, Agriculture, Automotive, Education, Gaming, Government, Healthcare, Hospitality, Industry, Manufacturing, Mining, Other, Retail, Telecommunications, Travel, industry as default };
